/** @format */

import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { FormikProps } from "formik";
import * as React from "react";
import { useAppSelector } from "../../app/hooks";
import { selectConstants } from "./Api/constantSlice";
import { ErrorBox } from "../custom/ErrorBox";

interface Props {
  formik: FormikProps<any>;
  isDisabled: boolean;
}
export default function BusinessType({ formik, isDisabled }: Props) {
  const selData = useAppSelector(selectConstants);
  const mapEnums = (key: string) => {
    switch (key) {
      case "FormalBusiness":
        return 12;
      case "InformalBusiness":
        return 40;
      case "NoBusiness":
        return 34;
      default:
        return -1;
    }
  };

  return (
    <>
      {selData.constantState.businessTypes && (
        <>
          <FormControl fullWidth>
            <InputLabel
              error={
                formik.touched.businessType &&
                Boolean(formik.errors.businessType)
              }
              id="demo-select-small"
            >
             Does your guardian have a business
            </InputLabel>
            <Select
              name="businessType"
              labelId="demo-select-small"
              id="demo-select-small"
              value={formik.values.businessType}
              label="Does your guardian have a business"
              disabled={isDisabled}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              error={
                formik.touched.businessType &&
                Boolean(formik.errors.businessType)
              }
            >
              <MenuItem value={-1} disabled>
              Does your guardian have a business
              </MenuItem>
              {selData.constantState.businessTypes.map(
                (item: string, key: number) => {
                  return (
                    <MenuItem key={key} value={mapEnums(item)}>
                      {item.replace(/([A-Z])/g, " $1").trim()}
                    </MenuItem>
                  );
                }
              )}
            </Select>
          </FormControl>

          <ErrorBox>
          {formik.touched.businessType &&
              (formik.errors.businessType as React.ReactNode)}
                    </ErrorBox>
        
        </>
      )}
    </>
  );
}
